import { useQuery } from '@tanstack/react-query'
import { marketApi } from '../../api/market'
import { useTerminalStore } from '../../store/terminalStore'

export function TickerTape() {
  const liveData = useTerminalStore((s) => s.liveData)
  const { data } = useQuery({
    queryKey: ['indices'],
    queryFn: marketApi.indices,
    refetchInterval: liveData ? 10_000 : false,
    staleTime: 30_000,
  })

  if (!data?.length) return (
    <div className="h-6 bg-bb-surface border-b border-bb-border" />
  )

  // Duplicate for seamless loop
  const items = [...data, ...data]

  return (
    <div className="h-6 bg-bb-surface border-b border-bb-border overflow-hidden shrink-0">
      <div className="bb-ticker-inner flex items-center h-full gap-6 px-4">
        {items.map((idx, i) => (
          <span key={i} className="flex items-center gap-1.5 shrink-0 text-xs">
            <span className="text-bb-subtle font-medium">{idx.symbol}</span>
            <span className="text-bb-text">{idx.price.toLocaleString()}</span>
            <span className={idx.change >= 0 ? 'text-bb-green' : 'text-bb-red'}>
              {idx.change >= 0 ? '▲' : '▼'}
              {Math.abs(idx.changePercent).toFixed(2)}%
            </span>
          </span>
        ))}
      </div>
    </div>
  )
}
